import Cronograma from '../../../components/ui/Admin/CronogramaComponents/Cronograma';

const CronogramaUI = () => {
  return (
    <div className="pb-4">
        <Cronograma />
    </div>
  );
};

export default CronogramaUI;
